import isFunction from 'lodash/isFunction';
import isString from 'lodash/isString';
import isObject from 'lodash/isObject';
import { showError, showModal } from 'controls/modals';
import { TIER_DESCRIPTIONS, VALID_PROCESSOR_PLAN_IDS } from 'libs/constants';

export {
  showError, showModal,
};

export const handleError = (fn, errorMessage = '', { rethrow = false, silent = false } = {}) => async (dispatch, ...rest) => {
  try {
    return await fn(dispatch, ...rest);
  } catch (err) {
    errorMessage = isFunction(errorMessage) ? errorMessage(dispatch, ...rest) : errorMessage;
    let exceptionMessage = isString(err)
      ? err : isObject(err)
        ? err.message || err.messages || err.responseText || JSON.stringify(err)
        : 'An unknown error has ocurred';

    if (!isString(exceptionMessage)) {
      exceptionMessage = JSON.stringify(exceptionMessage);
    }

    if (process.env.NODE_ENV !== 'production') {
      console.error(err);
    }

    if (!silent && !exceptionMessage) {
      dispatch(showError({ title: errorMessage || undefined, text: exceptionMessage }));
    }

    if (rethrow) {
      throw new Error(`${errorMessage}\n${exceptionMessage}`);
    }
  }
};

const hierarchy = {
  [TIER_DESCRIPTIONS.CORE]: 1,
  [TIER_DESCRIPTIONS.PRO]: 2,
  [TIER_DESCRIPTIONS.ULTIMATE]: 3,
};

export const getTierLevel = (tierDescription) => {
  const normalizedTier = Object.keys(hierarchy).find((key) => tierDescription.toUpperCase().includes(key));
  return normalizedTier ? hierarchy[normalizedTier] : 0;
};

export const getAllTierLevels = (tiersAvailable) => {
  const tiers = [TIER_DESCRIPTIONS.CORE, TIER_DESCRIPTIONS.PRO, TIER_DESCRIPTIONS.ULTIMATE];

  return tiers.filter((type) => tiersAvailable.some((tier) => tier.toUpperCase().includes(type)));
};

export const getMembershipStatuses = (userInfo, tiers) => {

  const hasValidMembership = userInfo?.memberships?.some(
    (membership) => membership.statusDescription === 'subscribed'
            && (tiers.includes(membership.tierDescription) && membership.tierDescription !== TIER_DESCRIPTIONS.ENTRY),
  );

  const validStatuses = ['subscribed', 'subscriptionpending'];

  const activeMembership = userInfo?.memberships?.data?.find(
    ({ statusDescription, processorPlanId }) => validStatuses.includes(statusDescription) && VALID_PROCESSOR_PLAN_IDS.includes(processorPlanId),
  );

  const userMembership = userInfo?.memberships?.find(
    (membership) => membership.statusDescription === 'subscribed',
  );

  const userTierLevel = userMembership ? getTierLevel(userMembership.tierDescription) : 0;
  const shouldSuggestUpgrade = userMembership && userTierLevel < hierarchy.ULTIMATE;

  const hasExpiredMembership = userInfo?.memberships?.some(
    (membership) => (membership.statusDescription === 'cancelled' || membership.statusDescription === 'nonrenew' || membership.statusDescription === 'expired')
    && tiers.includes(membership.tierDescription),
  );

  return ({
    hasValidMembership, hasExpiredMembership, activeMembership, shouldSuggestUpgrade, userMembership,
  });
};

export const normalizeTag = (value = '') => value.trim().toLowerCase().replace(/\s+/g, '_');
